import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { environment } from '@environments/environment';
import {
  SignupResponseModel,
  SignUpWithoutScheduleVisit,
  SocialLoginEnum,
  SocialLoginModel,
  SocialLoginResponseModel,
} from '@models';

import firebase from 'firebase/app';
import { from, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  constructor(
    private readonly angularFireAuth: AngularFireAuth,
    private readonly http: HttpClient
  ) {}

  public signWithSocialMedia(
    originAccount = SocialLoginEnum.GOOGLE
  ): Observable<SocialLoginModel> {
    let promise = new firebase.auth.GoogleAuthProvider();

    if (originAccount === SocialLoginEnum.FACEBOOK) {
      promise = new firebase.auth.FacebookAuthProvider();
    }

    return from(this.angularFireAuth.signInWithPopup(promise)).pipe(
      switchMap(({ user, additionalUserInfo }) =>
        from(user.getIdToken()).pipe(
          map((accessToken) => {
            const { uid } = user;
            const { profile } = additionalUserInfo as any;
            return {
              uid,
              accessToken,
              originAccount,
              profile,
            };
          })
        )
      )
    );
  }

  public loginWithSocialMedia(
    data: SocialLoginModel
  ): Observable<SocialLoginResponseModel> {
    return this.http.post<SocialLoginResponseModel>(
      environment.LOGIN_WITH_SOCIAL_MEDIA,
      data
    );
  }

  public signUpWithoutVisit(
    data: SignUpWithoutScheduleVisit
  ): Observable<SignupResponseModel> {
    return this.http.post<SignupResponseModel>(
      environment.SCHEDULE_VISIT.NV_SIGNUP,
      data
    );
  }

  public signUpWithSocialMedia(
    data: SignUpWithoutScheduleVisit
  ): Observable<SignupResponseModel> {
    return this.http.post<SignupResponseModel>(
      data.originAccount === SocialLoginEnum.GOOGLE
        ? environment.SCHEDULE_VISIT.NV_GOOGLE
        : environment.SCHEDULE_VISIT.NV_FACEBOOK,
      data
    );
  }
}
